<template>
  <div class="app-container">
    <basic-container>
      <div class="operation">
        <el-button @click="cancel" size="medium">取消</el-button>
        <el-button size="medium" type="primary" v-if="!isEdit" @click="onSubmit('configInfo')">保存</el-button>
        <el-button size="medium" type="primary" v-if="isEdit" @click="onEditSubmit('configInfo')">保存</el-button>
      </div>
      <el-form ref="configInfo" class="configInfo" :model="configInfo" label-width="100px" size="medium" :rules="rules">
        <el-row gutter="20">
          <el-form-item label="应用标题" prop="title">
            <el-input v-model="configInfo.title" placeholder="请输入应用标题"></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="description">
            <el-input :rows="3" type="textarea" placeholder="请选择输入描述" v-model="configInfo.description"></el-input>
          </el-form-item>
          <el-form-item label="链接" prop="path">
            <el-input v-model="configInfo.path" placeholder="请输入以'/'开始的路径(不包含域名)"></el-input>
            <i class="el-icon-question tip-icon" @click="isShowPathListDialog=true"></i>
          </el-form-item>
          <el-form-item  label="图片" class="img-box" prop="coverUrl" >
            <img :ref="coverUrl" class="image-url-options" v-show="configInfo.coverUrl" :src="configInfo.coverUrl">
            <el-upload
              action=""
              accept="image/jpeg, image/png, image/gif"
              :on-change="(file, fileList) => { handleImageChange(file, fileList, index) }"
              :on-remove="(file, fileList) => { handleImageRemove(file, fileList, index) }"
              :auto-upload="false"
              :multiple="false"
              :show-file-list="false"
              list-type="picture-card">
              <el-button size="small" type="primary">{{isEdit || isUploadSuccess[index] ? '重新上传' : '点击上传'}}</el-button>
            </el-upload>
            <span class="image-upload-tip">(推荐尺寸为160×216像素)</span>
          </el-form-item>
          <el-form-item label="分组" prop="groupId">
            <el-select 
             v-model="configInfo.groupId" filterable placeholder="请选择分组">
              <el-option
                v-for="item in groupIdList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排序" prop="sort" >
            <el-input-number :precision="0" v-model="configInfo.sort" controls-position="right" @change="handleChange" :min="0"></el-input-number>
          </el-form-item>
        </el-row>
      </el-form>
    </basic-container>
    <el-dialog
      title="提示"
      :visible.sync="isShowPathListDialog"
      width="30%">
      <div class="path" v-for="(path, index) in pathList" :key="index">
        {{ path.label }}: {{ path.value }}
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { createAppConfig, editAppConfig, getAppConfigInfo, getAppGroupDrop } from '@/api/app/config'
import { getFileKeyAsync } from '@/util/util'
import { getOSSVote } from '@/api/basic/aliyunoss';
import uploadService from '@/common/common-logic/upload-service';
export default {
  
  data() {
    var validPath = (rule, value, callback) => {
      if (value !== '' || value !== undefined || value!== null) {
        const reg = /^\/[^\/]{1}.*$/;
        if(!reg.test(value)){
          callback(new Error('请输入以 / 开始的路径(不包含域名)'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      configInfo: {
        title: '',
        description: '',
        path: '',
        coverUrl: '',
        sort: '',
        groupId: '',
      },
      id: '',
      isEdit: false,
      groupIdList: [],
      isUploadSuccess: [],
      rules: {
        title: [
          { type: 'string', required: true, message: '请输入应用标题', trigger: 'blur' },
          { max: 50, message: '不超过50个字符', trigger: 'blur' }
        ],
        description: [
          { max: 512, message: '不超过512个字符', trigger: 'blur' }
        ],
        path: [
          { required: true, validator: validPath, trigger: 'blur' },
          { max: 50, message: '不超过50个字符', trigger: 'blur' }
        ],
        coverUrl: [
          { type: 'string', required: true, message: '请上传图片', trigger: 'change'}
        ],
        groupId: [
          { required: true, message: '请选择分组', trigger: 'change' }
        ],
        sort: [
          { type: 'number', required: true, message: '请输入排序', trigger: 'blur' },
        ]
      },
      isShowPathListDialog: false,
      pathList: [{
        label: '投票列表',
        value: '/modules/vote-list',
      }, {
        label: '问卷列表',
        value: '/modules/questionnaire/all',
      }, {
        label: '活动列表',
        value: '/modules/activity/all',
      }],
    };
  },
  computed: {
  },
  created() {
    this.clearValidate();
    this.getGroupList();
  },
  mounted() {
    this.id = this.$route.params.id;
    if(this.id) {
      this.isEdit = true;
      this.getDetail();
    }
  },
  watch: {
  },
  methods: {
    getGroupList(){
      getAppGroupDrop().then( res => {
        let list = res.data.data
        list.forEach(item => {
          this.groupIdList.push({ label: item.groupName, value: item.id })
        });
      })
    },
    numberCheck(){
      this.configInfo.sort = this.configInfo.sort.replace(/[^\.\d]/g,'');
      this.configInfo.sort = this.configInfo.sort.replace('.','');
    },
    async handleImageChange (file, fileList, index) {
      if (!fileList || fileList.length === 0) {
        return false
      }
      const fileType = file.raw.type
      const isImage = fileType === 'image/jpeg'|| fileType === 'image/gif'|| fileType === 'image/png'
      if (!isImage) {
        this.$message.error('上传文件只能是图片格式!')
        if (fileList.length > 1) {
          // 当文件数大于1只保留之前的文件
          fileList.splice(1, 1)
        } else {
          // 否则清空控件的所有文件
          this.$refs['coverUrl'].clearFiles()
        }
        return false
      }
      // 当文件数大于1时替换之前的文件
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      const key = await getFileKeyAsync(file.raw, getOSSVote());
      try {
        const response = await uploadService.uploadFiles([{
          key: key,
          file: file.raw
        }])
        this.isUploadSuccess[index] = response[0].fileUrl
        this.configInfo.coverUrl = response[0].fileUrl
      } catch (error) {
        this.$message({
          message: '上传失败',
          type: 'error'
        })
      }
      return false
    },
    handleImageRemove (file, fileList, index) {
      this.isUploadSuccess[index] = null
      this.$refs['imageUrlOptions' + index].src = null
    },
    cancel () {
      this.$router.$avueRouter.closeTag()
      this.$router.go(-1)
    },
    onSubmit(formName) {
      const params = this.configInfo;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          createAppConfig(params).then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '创建成功',
                type: 'success'
              })
              this.$router.$avueRouter.closeTag()
              this.$router.push({
                path: `/app/config`,
              })
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          }).catch(err => {
            this.$message({
              message: err,
              type: 'error'
            })
          })
        } else {
          this.$message({
            message: '请通过验证',
            type: 'error'
          })
          return false;
        }
      });
    },
    clearValidate() {
      // 解决页面渲染时触发select change验证的问题
      this.$nextTick(()=>{
        this.$refs['configInfo'].clearValidate();
      })
    },
    getDetail() {
      getAppConfigInfo(this.id).then(res => {
        this.configInfo = res.data.data;
      }).catch(error => {
        this.$message({
          message: '获取配置详情失败',
          type: 'error'
        })
      })
    },
    onEditSubmit(formName) {
      const params = this.configInfo
      this.$refs[formName].validate((valid) => {
        if (valid) {
          editAppConfig(params).then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '编辑成功',
                type: 'success'
              })
              this.$router.$avueRouter.closeTag()
              this.$router.push({
                path: `/app/config`,
              })
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          }).catch(err => {
            this.$message({
              message: err,
              type: 'error'
            })
          })
        } else {
          this.$message({
            message: '请通过验证',
            type: 'error'
          })
          return false;
        }
      });
    }
  }
}
</script>
<style lang="scss" scoped>
  .operation {
    text-align: right;
  }
  .configInfo{
    width: 650px;
  }
  .img-box{
    margin-bottom: 15px;
    .image-url-options{
      width: 148px;
      height: 148px;
      border-radius: 6px;
      margin-right: 8px;
      float: left;
      object-fit: cover;
    }
  }
  .image-upload-tip {
    font-size: 12px;
    color: #7a869e;
  }
  .tip-icon {
    position: absolute;
    top: 10px;
    right: -20px;
    transform: scale(1.3,1.3);
    cursor: pointer;
    color: #66b1ff;
  }
  .path {
    height: 25px;
    font-size: 15px;
  }
  /deep/ .el-dialog__body {
    padding: 10px 20px;
  }
</style>
